var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 485,
    height: 329,
    viewBox: "0 0 485 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M422.473 316.363L254.449 289.102L290.566 222.529L433.991 245.798L422.473 316.363Z",
    fill: "#D36DCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M413.656 290.968L243.436 289.999L268.86 218.643L405.176 219.418L413.656 290.968Z",
    fill: "#FFD0B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M370.952 254.805C379.971 254.805 387.282 250.571 387.282 245.348C387.282 240.125 379.971 235.89 370.952 235.89C361.933 235.89 354.622 240.125 354.622 245.348C354.622 250.571 361.933 254.805 370.952 254.805Z",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M340.564 279.834C351.922 271.034 337.914 271.674 344.249 262.941C348.312 257.34 342.768 253.601 342.895 251.058C342.895 250.544 346.369 246.72 346.134 245.794C345.688 243.975 341.363 240.514 340.564 238.728C339.765 236.943 345.73 235.89 345.982 229.844",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M329.089 252.894C330.522 254.782 331.256 257.11 331.167 259.479C331.167 259.806 331.091 260.129 330.945 260.421C330.799 260.713 330.587 260.968 330.326 261.164C329.669 261.669 328.55 262.006 327.802 262.452C327.259 262.742 326.84 263.22 326.625 263.797C326.41 264.374 326.412 265.01 326.632 265.585C327.263 267.716 329.156 269.703 330.241 271.783C331.327 273.863 331.63 276.222 329.282 278.032",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M332.757 230.399C329.577 233.566 326.17 233.928 327.095 235.2L331.916 241.887C332.757 243.032 328.837 247.26 328.837 247.26",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M300.88 233.187C297.7 236.353 294.293 236.716 295.218 237.996L300.039 244.683C300.88 245.828 296.085 251.42 296.085 251.42",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M287.495 233.187C282.843 235.654 278.333 235.301 279.334 236.758L284.592 244.337C285.493 245.643 286.098 247.251 283.448 247.588C281.766 247.807 279.326 247.335 277.517 247.487C273.521 247.807 275.405 250.35 277.197 252.211C280.277 255.412 281.539 258.646 280.849 261.551C280.79 261.904 280.636 262.234 280.403 262.506C280.17 262.778 279.867 262.98 279.528 263.092C278.586 263.454 277.08 263.53 275.986 263.825C274.009 264.372 273.714 265.509 273.967 266.68C274.446 268.92 276.583 271.27 277.711 273.552C278.838 275.834 278.821 278.226 275.473 279.523",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M293.073 278.074C293.073 278.074 295.067 259.833 295.067 257.248",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M308.788 277.822C312.742 275.034 312.498 268.878 310.875 266.486C310.033 265.248 309.445 263.69 311.716 263.168C313.197 262.823 315.308 263.109 316.882 262.831C320.348 262.225 318.606 259.825 316.974 258.098C314.164 255.142 312.936 252.009 313.424 249.062C313.449 248.72 313.562 248.39 313.752 248.106C313.942 247.821 314.203 247.59 314.509 247.436C315.51 247.054 316.529 246.722 317.563 246.443C317.875 246.364 318.168 246.223 318.423 246.028C318.679 245.832 318.892 245.587 319.049 245.306C319.207 245.026 319.305 244.716 319.339 244.396C319.373 244.075 319.341 243.752 319.246 243.444C318.733 241.255 316.781 239.074 315.704 236.876C314.627 234.678 314.551 232.303 317.386 230.77",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M364.853 253.483L370.952 245.348L382.823 251.841",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M186.281 179.617C162.8 178.893 113.424 176.029 112.928 186.742C112.431 197.454 184.691 192.064 184.741 206.339C184.792 220.613 30.2868 223.965 0.235565 227.923",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M267.92 168.744C267.92 162.748 248.89 157.881 225.418 157.881C201.946 157.881 182.915 162.748 182.915 168.744V180.973C182.915 186.977 201.946 191.845 225.418 191.845C248.89 191.845 267.92 186.977 267.92 180.973V168.744Z",
    fill: "#FF5F2F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M276.207 10.2154C253.719 -5.14566 227.934 0.210512 227.934 54.648C227.934 85.9597 225.645 161.915 225.645 161.915",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M311.29 59.9369C317.414 59.9369 322.378 54.9673 322.378 48.8371C322.378 42.7069 317.414 37.7374 311.29 37.7374C305.166 37.7374 300.201 42.7069 300.201 48.8371C300.201 54.9673 305.166 59.9369 311.29 59.9369Z",
    fill: "#FFD0B1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M291.957 62.7329C306.612 52.7027 315.984 45.8896 329.42 34.2677C318.601 27.1514 311.391 17.7023 298.923 14.2073C286.455 10.7124 275.518 13.4999 276.207 28.002C276.894 41.1528 282.52 53.5582 291.957 62.7329V62.7329Z",
    fill: "#FF5F2F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M290.661 14.9653L279.766 0L263.95 13.2472L278.74 24.827L290.661 14.9653Z",
    fill: "#FF5F2F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M184.741 169.502C189.789 173.191 196.25 174.244 202.467 174.918C212.385 175.986 222.364 176.366 232.334 176.054",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M328.284 34.0235C320.819 40.7798 313.016 47.152 304.904 53.1154",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M215.197 250.999C211.587 249.87 205.698 249.129 199.044 249.129C192.599 249.129 186.878 249.82 183.244 250.889C181.426 251.089 179.746 251.953 178.526 253.316C177.306 254.679 176.631 256.445 176.631 258.275V319.231C176.631 320.825 177.143 322.376 178.092 323.656C179.04 324.936 180.375 325.876 181.898 326.339C185.347 327.661 191.733 328.554 199.044 328.554C209.139 328.554 217.443 326.869 218.738 324.68C219.492 323.986 220.093 323.144 220.504 322.206C220.915 321.268 221.128 320.255 221.128 319.231V258.275C221.128 256.564 220.537 254.905 219.457 253.58C218.376 252.254 216.871 251.342 215.197 250.999Z",
    fill: "#178EFD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M215.197 250.999C211.587 249.87 205.698 249.129 199.044 249.129C192.599 249.129 176.631 249.441 176.631 258.275V319.231C176.631 320.825 177.143 322.376 178.092 323.656C179.04 324.936 180.375 325.876 181.898 326.339C185.347 327.661 191.733 328.554 199.044 328.554C209.139 328.554 217.443 326.869 218.738 324.68C219.492 323.986 220.093 323.144 220.504 322.206C220.915 321.268 221.128 320.255 221.128 319.231V258.275C221.128 256.564 220.537 254.905 219.457 253.58C218.376 252.254 216.871 251.342 215.197 250.999V250.999Z",
    fill: "#178EFD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M196.81 292.521C204.831 292.043 203.186 286.311 209.563 286.311C212.413 286.311 216.875 290.133 221.185 294.613V287.19C217.567 281.898 213.771 277.637 210.701 277.15C204.586 276.195 201.424 280.395 196.81 280.672C189.565 281.121 181.316 270.704 176.576 264.408C176.32 265.207 176.571 270.234 176.576 271.084V282.863C182.472 287.658 190.375 292.903 196.81 292.521Z",
    fill: "#DFF6FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M207.245 256.508C212.377 256.508 216.538 255.468 216.538 254.185C216.538 252.902 212.377 251.862 207.245 251.862C202.112 251.862 197.951 252.902 197.951 254.185C197.951 255.468 202.112 256.508 207.245 256.508Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M176.614 289C182.386 293.101 189.983 297.421 196.183 297.068C204.184 296.646 202.543 291.594 208.903 291.594C211.89 291.594 216.627 295.257 221.111 299.485V293.211C217.325 288.158 213.278 283.997 210.048 283.559C203.94 282.717 200.793 288.536 196.183 288.781C189.453 289.143 181.755 281.294 176.614 274.851V289Z",
    fill: "#FF5F2F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M207.176 255.74L210.146 224.934L235.503 227.923",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M197.951 319.706C201.544 319.706 204.457 316.794 204.457 313.201C204.457 309.608 201.544 306.695 197.951 306.695C194.358 306.695 191.446 309.608 191.446 313.201C191.446 316.794 194.358 319.706 197.951 319.706Z",
    fill: "#FF5F2F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M212.933 275.285C215.549 275.285 217.67 273.162 217.67 270.544C217.67 267.925 215.549 265.802 212.933 265.802C210.317 265.802 208.197 267.925 208.197 270.544C208.197 273.162 210.317 275.285 212.933 275.285Z",
    fill: "#DFF6FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M189.122 313.201C193.485 313.201 197.022 309.664 197.022 305.301C197.022 300.938 193.485 297.401 189.122 297.401C184.76 297.401 181.223 300.938 181.223 305.301C181.223 309.664 184.76 313.201 189.122 313.201Z",
    fill: "#DFF6FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M179 257C182.667 259.667 195.7 264 218.5 260",
    stroke: "black",
    strokeWidth: 3.25
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M290.886 207.283V118.33C290.886 116.097 291.645 113.931 293.038 112.187C294.43 110.443 296.374 109.226 298.55 108.734L391.295 87.8068C392.119 87.6207 392.974 87.6226 393.797 87.8122C394.621 88.0018 395.391 88.3743 396.051 88.9021C396.71 89.43 397.243 90.0996 397.61 90.8615C397.976 91.6234 398.166 92.458 398.167 93.3036V135.393V177.483L483.711 188.665L375.849 222.815L290.886 207.283Z",
    fill: "#178EFD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M390.613 182.61L309.265 202.352L372.688 214.476L456.757 191.06L390.613 182.61Z",
    fill: "#0254A1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M318.875 196.062L401.477 212.85",
    stroke: "#178EFD",
    strokeWidth: 1.98,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M337.145 191.868L419.747 208.657",
    stroke: "#178EFD",
    strokeWidth: 1.98,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M352.292 187.675L438.017 204.464",
    stroke: "#178EFD",
    strokeWidth: 1.98,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M446.818 185.186L353.657 214.476",
    stroke: "#178EFD",
    strokeWidth: 1.98,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M426.619 183.898L333.45 213.188",
    stroke: "#178EFD",
    strokeWidth: 1.98,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M406.411 182.61L313.25 211.9",
    stroke: "#178EFD",
    strokeWidth: 1.98,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M366.828 183.482L442.619 197.53",
    stroke: "#178EFD",
    strokeWidth: 1.98,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M377.583 174.907L390.291 171.892V97.7717L301.013 118.078V193.062L305.625 191.971",
    fill: "#DDF6FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M290.886 208.15L375.849 223.682L483.711 189.531",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M329.233 186.998C329.233 186.998 345.801 130.781 339.102 128.787C334.795 127.499 330.755 115.257 329.727 110.797C327.139 99.4655 318.149 89.2494 320.628 87.9773C328.935 83.7212 334.803 103.368 340.129 101.185C344.836 99.2378 333.477 60.6662 338.874 59.8652C345.267 58.9151 348.068 89.1316 350.735 88.9196C353.7 88.6997 353.826 53.4183 359.701 52.9785C365.577 52.5388 358.76 88.6369 361.27 88.6683C364.541 88.7154 373.821 55.0359 379.477 56.2059C385.133 57.3759 368.746 92.9008 371.852 94.7775C374.786 96.5522 387.039 72.3664 392.522 74.1332C397.566 75.7509 356.956 129.682 359.874 179.585",
    fill: "#D36DCD"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M343.157 105.842C348.687 107.656 353.935 113.985 354.43 116.977",
    stroke: "black",
    strokeWidth: 3.25,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.5c8c400b3b994b53e0c89315b8efa065.svg";
export { ForwardRef as ReactComponent };